// User status type for the profile status indicator
export type UserStatus = 'available' | 'away' | 'busy' | 'out-of-office' | 'on-the-phone';

// Away status option keys
export type AwayStatusOption = 'getting_coffee' | 'coming_back' | 'custom';

// At-work location (Office, Remote, Other, Custom) - icon varies by selection; custom uses user-entered phrase
export type AtWorkLocation = 'office' | 'remote' | 'other_location' | 'custom';

// Status colors mapping
export const STATUS_COLORS: Record<UserStatus, string> = {
    available: '#2ECC71', // Green
    away: '#F1C40F', // Yellow
    busy: '#E74C3C', // Red
    'out-of-office': '#7F8C8D', // Gray
    'on-the-phone': '#9B59B6' // Purple
};

export interface IIdentityClaims {
    uid: string;
    displayName: string;
    roles: string[];
    type: string;
    tid: string;
    upn: string;
    areas: string[];
    idp: string;
    profileImageURL?: string;
    msTenantId?: string;
    visitorInvId?: string;
    orgStatus?: 'active' | 'trial' | 'standby' | 'non-relevant' | 'active_direct';
}

export interface IProfile {
    displayName: string;
    uid: string;
    type: 'user' | 'visitor' | 'unconfirmed_visitor' | 'auto-confirmed-visitor' | 'manager' | 'owner';
    profileImage?: string;
    room?: string;
    status?: string;
    host?: string;
    invitationId?: string;
    campusId?: string;
}
export interface IVisitorProfile {
    displayName: string;
    eventName: string;
    host: string;
    hostIds: string[];
    invitationId: string;
    subInfo: string;
    type: 'visitor' | 'unconfirmed_visitor' | 'auto-confirmed-visitor';
    uid: string;
    socketId?: string;
    campusId?: string;
    hostUsers: any;
}
